module.exports = __webpack_public_path__ + "assets/webhook.8ac90fd0.svg";